<template>
    <Header
        :elements="countElements"
        :current="currentElement"
    ></Header>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="MuiBox-root css-1n2tziu">
                <div class="MuiGrid-root MuiGrid-container css-15zova9 slide-up-enter-done" transition="250">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-3 MuiGrid-grid-md-4 css-4lvwcn">
                        <div class="MuiBox-root css-1yu9eo3">
                            <div class="MuiGrid-root css-skpbsy">
                                <div class="MuiGrid-root css-vnk25j" type="lottie">
                                    <div>
                                        <Freezeframe
                                            src="/images/free-animated-icon-fast-forward-7740748.gif"
                                        ></Freezeframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-1 css-se8e58">
                        <div class="MuiBox-root css-8atqhb"></div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-7 css-xjtbym">
                        <div class="module-checkout">
                            <div class="checkDetail">
                                <div>
                                    <!-- "Repeater" of selected classes starts -->

                                    <div class="inputSec">
                                        <h2 class="topSpace topSpace_with-dot" style="color:#000"><b>Class {{ code }} - {{ name }}</b></h2>
                                        <p><b>{{ description }}</b></p>
                                        <div style="margin: 10px 0px;">
                                            <p>Have you already begun providing/selling these products/services in at least 2 US States?</p>
                                            <RadioCheckbox
                                                :value="is_using_trademark"
                                                @change_c="is_using_trademark = $event;changeIsUsingTrademark()"
                                                type="radio"
                                                value_v="1"
                                                text="Yes"
                                                name="is_usifalseng_trademark"
                                            ></RadioCheckbox>
                                            <RadioCheckbox
                                                :value="is_using_trademark"
                                                @change_c="is_using_trademark = $event;changeIsUsingTrademark()"
                                                type="radio"
                                                value_v="0"
                                                text="No"
                                                name="is_using_trademark"
                                            ></RadioCheckbox>
                                        </div>
                                    </div>

                                    <div v-if="is_using_trademark > 0" class="inputSec" id="div_033">
                                        <div class="row addition-block-sou">
                                            <div class="col-6">
                                                <h3>First use anywhere
                                                    <Popper>
                                                        <span class="GetHelpItem">
                                                            <span class="popover-icon">
                                                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                                                            </span>
                                                            Get Help
                                                        </span>
                                                        <template #content>
                                                            <div class="popper-content">
                                                                <b>What is First Use Anywhere?</b>
                                                                <p>This is where you designate the date you first used the mark <b>anywhere before actually selling any goods or services</b>.
                                                                    It can be your date of incorporation or the date of your first prototype.
                                                                    The date of first use anywhere can be the same as the date of the first use in commerce.
                                                                </p>
                                                                <b>Need help?</b>
                                                                <b>Call customer service at <span>1-833-863-5483</span></b>
                                                            </div>
                                                        </template>
                                                    </Popper>
                                                </h3>
                                                <table id="masterBody_rptSelectedClasses_dtFirstUseAnywhere_0_LP" class="dxeLoadingPanel_Material dxlpLoadingPanel_Material" style="left:0px;top:0px;z-index:30000;display:none;">
                                                    <tbody><tr>
                                                        <td class="dx" style="padding-right:0px;"><img class="dxlp-loadingImage dxlp-imgPosLeft" src="" alt="" style="vertical-align:middle;"></td><td class="dx" style="padding-left:0px;"><span id="masterBody_rptSelectedClasses_dtFirstUseAnywhere_0_TL">Loading…</span></td>
                                                    </tr>
                                                    </tbody></table><table class="dxeButtonEditSys dxeButtonEdit_Material roundedBorders" id="masterBody_rptSelectedClasses_dtFirstUseAnywhere_0" style="width:100%;">
                                                <tbody><tr>
                                                    <td class="dxic" style="width:100%;">
                                                        <Datepicker v-model="first_use_anywhere"></Datepicker>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                            </div>
                                            <div class="col-6">
                                                <h3>First use in commerce
                                                    <Popper>
                                                        <span class="GetHelpItem">
                                                            <span class="popover-icon">
                                                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                                                            </span>
                                                            Get Help
                                                        </span>
                                                        <template #content>
                                                            <div class="popper-content">
                                                                <b>What is First use in commerce?</b>
                                                                <p>This is where you designate the date you first sold goods or services using the mark.
                                                                    It can be the same as the Date of First Use of Mark Anywhere.
                                                                    The difference is that this is the first time the mark was used in commerce in the United States or
                                                                    its territories in interstate commerce related to an actual sale.
                                                                </p>
                                                                <b>Need help?</b>
                                                                <b>Call customer service at <span>1-833-863-5483</span></b>
                                                            </div>
                                                        </template>
                                                    </Popper>
                                                </h3>
                                                <table id="masterBody_rptSelectedClasses_dtFirstUseInCommerce_0_LP" class="dxeLoadingPanel_Material dxlpLoadingPanel_Material" style="left:0px;top:0px;z-index:30000;display:none;">
                                                    <tbody><tr>
                                                        <td class="dx" style="padding-right:0px;"><img class="dxlp-loadingImage dxlp-imgPosLeft" src="" alt="" style="vertical-align:middle;"></td><td class="dx" style="padding-left:0px;"><span id="masterBody_rptSelectedClasses_dtFirstUseInCommerce_0_TL">Loading…</span></td>
                                                    </tr>
                                                    </tbody></table><table class="dxeButtonEditSys dxeButtonEdit_Material roundedBorders" id="masterBody_rptSelectedClasses_dtFirstUseInCommerce_0" style="width:100%;">
                                                <tbody><tr>
                                                    <td class="dxic" style="width:100%;">
                                                        <Datepicker v-model="first_use_in_commerce"></Datepicker>
                                                  </td>
                                                </tr>
                                                </tbody></table>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else id="ans_1_0" class="ans_1 topSpace" style="">
                                        <p>No Problem. If you have not sold your products/services in interstate commerce, we can request a 6-month extension of time with the USPTO</p>
                                    </div>
                                    <!-- "Repeater" ends -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="css-1l6i970">
                <div class="css-1c73k7k">
                    <BottomButton
                        :active="true"
                        @click.native="back"
                        text="Back"
                        class_b="button-back"
                    ></BottomButton>
                    <BottomButton
                        :active="is_continue"
                        @click.native="next"
                        text="Next"
                        class_b="button-next"
                    ></BottomButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Freezeframe from '@/components/Freezeframe.vue'
import Header from '@/components/Header-Short-New.vue'
import InputTextareaElement from "@/ui/Input-Textarea";
import Datepicker from "@/ui/Datepicker";
import BottomButton from '@/ui/Bottom-Button.vue'
import http from "@/api/http";
import RadioCheckbox from "@/ui/Radio-Checkbox";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        BottomButton,
        Freezeframe,
        RadioCheckbox,
        Datepicker,
        InputTextareaElement
    },
    data() {
        return {
            is_using_trademark: 0,
            first_use_anywhere: '',
            first_use_in_commerce: '',
            code: '',
            name: '',
            description: '',
            classes: []
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        changeIsUsingTrademark() {
            this.first_use_anywhere = false
            this.first_use_in_commerce = false
        },
        async init(){
            let { data } = await http.get('statement-of-use/step-using/' + this.$route.params.key);

            if (data.res) {
                this.classes = data.data.data.classes
                for (let i = 0; i < this.classes.length; i++) {
                    if (this.classes[i].code == this.$route.params.class) {
                        this.is_using_trademark = this.classes[i].is_using_trademark
                        this.first_use_anywhere = this.classes[i].first_use_anywhere
                        this.first_use_in_commerce = this.classes[i].first_use_in_commerce
                        this.code = this.classes[i].code
                        this.name = this.classes[i].name
                        this.description = this.classes[i].description
                    }
                }

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
        async back(){
            if (this.prew_class && this.prew_class.is_using_trademark) {
                this.$router.push({ path: '/statement-of-use/step-proof/' + this.prew_class.code + '/' + this.$route.params.key })
            } else if (this.prew_class && !this.prew_class.is_using_trademark) {
                this.$router.push({ path: '/statement-of-use/step-using/' + this.prew_class.code + '/' + this.$route.params.key })
            } else {
                this.$router.push({ path: '/statement-of-use/step-owners/' + this.$route.params.key })
            }
        },
        async next(){
            let { data } = await http.put('statement-of-use/step-using/' + this.$route.params.class + '/' + this.$route.params.key, {
                    is_using_trademark: this.is_using_trademark,
                    first_use_anywhere: this.first_use_anywhere,
                    first_use_in_commerce: this.first_use_in_commerce,
            });

            if (data.res) {
                if (this.is_using_trademark > 0) {
                    this.$router.push({ path: '/statement-of-use/step-proof/' + this.$route.params.class + '/' + this.$route.params.key })
                } else if (this.is_using_trademark < 1 && this.next_code) {
                    this.$router.push({ path: '/statement-of-use/step-using/' + this.next_code + '/' + this.$route.params.key })
                } else if (this.is_using_trademark < 1 && !this.next_code) {
                    this.$router.push({ path: '/statement-of-use/step-end/' + this.$route.params.key })
                }
            }
        }
    },
    computed: {
        is_continue() {
            if (this.is_using_trademark < 1) {
                return true
            }

            if (this.is_using_trademark && this.first_use_anywhere && this.first_use_in_commerce) {
                return true
            }

            return false
        },
        prew_class() {
            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].code == this.$route.params.class && typeof this.classes[i - 1] !== 'undefined') {
                    return this.classes[i - 1]
                }
            }
        },
        next_code() {
            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i]['code'] == this.$route.params.class && typeof this.classes[i + 1] !== 'undefined') {
                    return this.classes[i + 1]['code']
                }
            }
        },
        countElements() {
            let num = 4

            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].is_using_trademark) {
                    num += 2
                } else {
                    num += 1
                }
            }

            return this.classes.length ? num + 2 : 0
        },
        currentElement() {
            let num = 4

            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].code == this.$route.params.class) {
                    num += 1
                    return num
                } else if (this.classes[i].is_using_trademark) {
                    num += 2
                } else {
                    num += 1
                }
            }

            return this.classes.length ? num : 0
        }
    }
}
</script>

